module.exports = __webpack_public_path__ + "img/hr-green-bush-mini-06.646f16a3.png";